<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="mx-1"
          v-bind="attrs"
          v-on="on"
          @click="sendEvent"
          :color="color"
          :disabled="disabled"
          small
          depressed
          fab
        >
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ButtonTooltip',

  props: ['color', 'icon', 'tooltip', 'type', 'disabled'],

  methods: {
    sendEvent() {
      this.$emit('event-click', this.type)
    }
  }
}
</script>

<style></style>
